<form nzLayout="vertical" nz-form [formGroup]="widget_form" (ngSubmit)="onChangeForm()">
    <div class="widget">
        <ng-container *ngIf="widget_data?.settings">
            <penji-settings-form [formGroup]="widget_form" [settings]="widget_data?.settings"></penji-settings-form>
        </ng-container>
        <button type="submit" nz-button nzType="primary" nzBlock>Submit</button>
    </div>
</form>